import React from 'react';
import { FieldLayout } from "../FieldLayout";
import { SelectableTextInput } from "../controls/SelectableTextInput";
import { parseTextInputValue, parseTextToNumber } from "../controls/NumberInput/helpers";
import { CONTROL_SIZE } from "../common/public";
export var preventInputNotNumberValue = function (newValue, minValue, maxValue) {
    if (newValue === '') {
        return false;
    }
    var _a = parseTextInputValue(newValue), value = _a.value, isInvalid = _a.isInvalid;
    if (isInvalid) {
        return true;
    }
    if ((value || 0) > maxValue || (value || 0) < minValue) {
        return true;
    }
    var numberValue = parseTextToNumber(value);
    return numberValue === undefined;
};
export var SelectableNumberInputField = function (_a) {
    var label = _a.label, errorText = _a.errorText, error = _a.error, data = _a.data, minValue = _a.minValue, maxValue = _a.maxValue, value = _a.value, onChange = _a.onChange;
    return (React.createElement(FieldLayout, { label: label, error: errorText },
        React.createElement(SelectableTextInput, { preventInputValue: function (newValue) {
                return preventInputNotNumberValue(newValue, minValue, maxValue);
            }, value: value === null ? '' : "" + value, data: data, onChange: function (value) {
                onChange(value === '' ? null : parseInt(value, 10));
            }, size: CONTROL_SIZE.xxs, error: error })));
};
//# sourceMappingURL=SelectableNumberInputField.js.map